import { API_BASE_URL } from '@/shared/api';

export interface DocumentShareFileInfo {
  documentId: number;
  docUrl?: string | null;
  minioObjectName?: string | null;
}

export function buildDocumentShareUrl(fileInfo: DocumentShareFileInfo): string {
  if (!fileInfo?.documentId) {
    throw new Error('Invalid document revision: missing documentId');
  }

  if (fileInfo.docUrl) {
    return fileInfo.docUrl;
  }

  const fileExtension = fileInfo.minioObjectName?.split('.').pop()?.toLowerCase();
  if (!fileExtension) {
    throw new Error('Invalid document revision: no file available');
  }

  const endpoint = fileExtension === 'pdf' ? 'pdf' : 'download';
  const base = API_BASE_URL.startsWith('http')
    ? API_BASE_URL
    : globalThis.location.origin + API_BASE_URL;

  return `${base}/documents/${fileInfo.documentId}/${endpoint}`;
}
